export { default as ClockIcon } from "./clock.svg";
export { default as GrapesIcon } from "./grapes.svg";
export { default as InformationIcon } from "./info.svg";
export { default as LinkArrow } from "./link-arrow.svg";
export { default as Logo } from "./Logo.svg";
export { default as PlacesIcon } from "./place.svg";
export { default as TimeIcon } from "./time.svg";
